'use strict'
import { has, get } from 'lodash-es'
import { Toast } from 'vant'
import Loader from '@/utils/loader'

const actions = {
  // 取得热门话题 ( 只取第一页; 首页用 )
  async getHotTopics({ commit }, { pageSize = 10 } = {}) {
    Loader.loading()
    const { getRankingTopicAPI } = await import('@/api/')
    const response = await getRankingTopicAPI({
      page: 1,
      page_size: pageSize
    })
    Loader.cancel()
    if (response?.body?.list) {
      commit('setHotTopics', response.body.list)
      return response.body.list
    } else {
      return []
    }
  },
  // 取得话题榜
  async getRankingTopic({ state, rootGetters, commit }, { page = 1, pageSize = 20 } = {}) {
    Loader.loading()
    const params = {
      page,
      page_size: pageSize
    }
    const { getRankingTopicAPI } = await import('@/api/')
    const response = await getRankingTopicAPI(params)
    Loader.cancel()
    if (response?.body?.list) {
      const result = {
        list: response.body.list || [],
        pageSize, // 一页几笔
        total: +response.body.page_info.total, // 总笔数
        page: response.body.page_info.current_page, // 第几页
        pages: response.body.page_info.pages, // 总页数
      }
      // H5 需要拼贴结果
      if (rootGetters.isH5View) {
        const collageList = result.page === 1 ? result.list : [ ...state.topicRanking.list, ...result.list]
        commit('setTopicRanking', {
          ...result,
          list: collageList
        })
      } else {
        commit('setTopicRanking', result)
      }
      return result
    } else {
      // TODO: 错误处理
      // Toast({
      //   message: response.head.errMsg,
      // })
      return response.head
    }
  }
}

export default actions
